import React from 'react';
import { CtaButton } from './CtaButton';
import { CountdownPanel } from './CountdownPanel';
import { TrustIcons } from './TrustIcons';
import { checkoutUrl, currencyNote } from '../data/content';
interface FinalCtaProps {
  showUrgency?: boolean;
}
export function FinalCta({
  showUrgency = true
}: FinalCtaProps) {
  return <section className="w-full bg-canvas py-16 md:py-24" data-id="element-54" data-mp="15ckjkv8vocby">
      <div className="mx-auto w-full max-w-content px-5 md:px-8" data-id="element-55" data-mp="1jcvatze3nsxn">
        {showUrgency && <CountdownPanel headline="Ti rimangono meno di 48 ore per accedere a questo prezzo speciale" subtext="Dopo torna a 47,00 € | Oggi: 19 € + 3 bonus | Domani è tardi" data-id="element-56" data-mp="1ee1zodmace0n" />}

        <div className="mx-auto mt-14 max-w-narrow text-center" data-id="element-57" data-mp="1o3lftbim5trt">
          <h2 className="font-display text-[2rem] font-extrabold leading-tight tracking-tight text-night md:text-5xl" data-id="element-58" data-mp="1o67ojeh8qfbm">
            La tua opportunità è adesso
          </h2>

          <p className="mt-6 text-lg leading-relaxed text-gray-600 md:text-xl" data-id="element-59" data-mp="1x6cv5mem19oq">
            Hai tutto ciò che ti serve per trasformare la tua campagna di Settembre Giallo in
            un’esperienza che davvero salva vite. Il materiale esiste. La strategia esiste. Le
            testimonianze esistono. I bonus esistono. Ti manca solo la tua decisione.
          </p>
          <p className="mt-5 text-lg leading-relaxed text-gray-600 md:text-xl" data-id="element-60" data-mp="123wnw7m4c0vw">
            Non lasciare che un altro anno passi vedendo come altri professionisti hanno gli
            strumenti e tu no.{' '}
            <span className="font-display font-extrabold text-night" data-id="element-61" data-mp="1b28n2y11w6zy">
              La salute mentale non può aspettare.
            </span>
          </p>
          <p className="mt-5 text-lg text-gray-600" data-id="element-62" data-mp="1ktd03s761hs5">
            Ricorda: hai 7 giorni di garanzia. Se non ti convince, ti restituiamo tutto. Senza
            rischi.
          </p>

          <div className="mt-10" data-id="element-63" data-mp="1pqmnz3ewpldv">
            <p className="font-display text-2xl font-extrabold tracking-tight text-night" data-id="element-64" data-mp="1ttj9p2zqtxm1">
              Oggi: 19 €
            </p>
            <p className="mx-auto mt-2 max-w-md text-sm leading-relaxed text-gray-500" data-id="element-65" data-mp="3qv70gb47286a">
              {currencyNote}
            </p>
            <CtaButton size="xl" href={checkoutUrl} className="mt-5 w-full" data-id="element-66" data-mp="3ltrg6l9uc5oy">
              🟢 Accedi al protocollo ora
            </CtaButton>
          </div>

          <TrustIcons className="mt-8" data-id="element-67" data-mp="3uvh6tovwf0lo" />
        </div>
      </div>
    </section>;
}